import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user !== null) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center bg-[#0F172A] px-5" data-testid="admin-login-page">
      <div className="absolute top-0 left-0 w-96 h-96 rounded-full opacity-20 blur-3xl" style={{ background: "#6C2BD9" }} />
      <div className="relative w-full max-w-md rounded-[1.75rem] bg-white p-8 sm:p-10 shadow-2xl">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <img src="/logo.jpeg" alt="Digital Madhuraa" className="w-10 h-10 rounded-xl object-cover ring-1 ring-slate-200" style={{ objectPosition: "center 40%" }} />
          <span className="font-head font-extrabold text-lg text-slate-900">Digital Madhuraa</span>
        </Link>

        <div className="w-12 h-12 rounded-xl grid place-items-center text-white mb-4" style={{ background: "linear-gradient(135deg,#6C2BD9,#2563EB)" }}>
          <Lock size={22} />
        </div>
        <h1 className="font-head font-extrabold text-2xl text-slate-900">Admin Login</h1>
        <p className="text-slate-500 mt-1">Sign in to manage content and leads.</p>

        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-email" className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:border-[var(--dm-purple)] focus:ring-2 focus:ring-purple-100" />
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-password" className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:border-[var(--dm-purple)] focus:ring-2 focus:ring-purple-100" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full py-3.5 font-head font-bold text-white flex items-center justify-center gap-2 transition-transform hover:-translate-y-0.5 disabled:opacity-70" style={{ background: "linear-gradient(135deg,#6C2BD9,#2563EB)" }}>
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
